import React from "react";
import { ReactComponent as ArrowRightIcon } from "../../../../../assets/icons/svg/arrow-right.svg";
import "./Team.scss";
import Button from "../../reusable/Button/Button";
import { useHistory } from "react-router-dom";

export default function StaffMember(props) {
  const history = useHistory();
  function addDefaultSrc(event) {
    event.target.src = `https://api.thefootballbrain.app/uploads/staff_members/placeholder_antrenor.png`;
  }

  return (
    <div
      className="staff-card-3"
      style={{ borderRadius: 30 }}
    >
      <div className="staff-image">
        <img
          src={`https://api.thefootballbrain.app/uploads/staff_members/${props.item.id_staff_member}.jpg`}
          alt="staff"
          style={{ borderRadius: "30px 30px 0 0" }}
          onError={addDefaultSrc}
        />
      </div>

      <div
        className="staff-name notranslate"
        style={{ color: props.config_options.news_title_color }}
      >
        {props.item.staff_member_name}
      </div>
      <div
          className="staff-label"
          style={{
            borderRadius:
              props.config_options.id_theme == 2 ? "0px 15px 0px 0px" : 0,
            color: props.config_options.buttons_color,
          }}
        >
          {props.item.staff_member_role}
        </div>
      <div className="see-more-button-staff-3">
        <Button
          className="arrow-button-3"
          onClick={() =>
            history.push(
              `/staff/${props.item.staff_member_name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-zA-Z0-9 \-]/g, "")
                .replaceAll(" ", "-")}-${props.item.id_staff_member}`
            )
          }
          theme={props.config_options.id_theme}
          color={props.config_options.buttons_text_color}
          backgroundColor={props.config_options.buttons_color}
        >
          Vezi profil{" "}
          <ArrowRightIcon
            fill={props.config_options.buttons_text_color}
            className="discover-more-button-icon-3"
          />
        </Button>
      </div>
    </div>
  );
}
